const data = {
	"width": 20,
	"height": 20,
	"body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 2a1 1 0 0 0-1 1v1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V3a1 1 0 1 0-2 0v1H7V3a1 1 0 0 0-1-1Zm0 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H6Z\" clip-rule=\"evenodd\"/>"
};
export default data;
